module.exports = __webpack_public_path__ + "img/oficina_baner_oficial.f5a6c176.jpg";